import { Link } from 'react-router-dom';
import { featuredArticles } from '@/mocks/articles';

export default function ArticleCards() {
  return (
    <section id="articles" className="py-16 md:py-24 px-4 md:px-6 lg:px-10">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-4 py-1.5 bg-accent-100 text-accent-700 text-xs font-semibold rounded-full mb-4 tracking-wide uppercase">
            Latest Guides
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
            Kakobuy Spreadsheet Resources
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            In-depth guides and resources to help you master the Kakobuy shopping experience
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {featuredArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/blog/${article.slug}`}
              className="group bg-background-50 rounded-2xl overflow-hidden border border-background-200/60 card-hover cursor-pointer"
            >
              <div className="p-6 md:p-8">
                <div className="flex items-center gap-3 mb-4">
                  <span className="px-3 py-1 bg-accent-100 text-accent-700 text-xs font-semibold rounded-full whitespace-nowrap">
                    {article.category}
                  </span>
                  <span className="text-xs text-foreground-400">{article.readTime}</span>
                </div>
                <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-900 mb-3 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed mb-5 line-clamp-3">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-foreground-400">{article.date}</span>
                  <span className="inline-flex items-center gap-1 text-sm font-semibold text-primary-600 group-hover:text-primary-700 transition-colors whitespace-nowrap">
                    Read Article
                    <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/blog/complete-kakobuy-spreadsheet-guide"
            className="inline-flex items-center gap-2 px-6 py-3 bg-foreground-900 text-background-50 rounded-full text-sm font-semibold hover:bg-foreground-800 transition-all cursor-pointer whitespace-nowrap"
          >
            View All Articles
            <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}